<template>
  <div class="other">
    <el-upload
      accept=".pdf"
      action="/prod-api/recruitment/sso/uploadfile"
      name="uploadfile"
      :limit="1"
      :headers="{ Authorization: 'Bearer ' + getToken() }"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :file-list="fileList"
      :show-file-list="false"
      :disabled="!canEdit"
    >
      <div class="title">
        &nbsp;附件
        <el-tag type="danger">必填</el-tag>
        <el-button
          size="mini"
          type="primary"
          plain
          style="margin-left: 50px"
          :disabled="!canEdit"
          :title="canEdit ? '' : isSpecific ? '投递岗位后无法再更改简历' : '请取消投递后再更改简历'"
          >上传</el-button
        >
      </div>
      <template #tip>
        <div class="el-upload__tip desc">
          请根据招聘公告上传相关证明材料，并确保材料中的学历学位认证报告在有效期内，附件只支持PDF格式，文件大小50M以内，限制上传一个文件
        </div>
      </template>
      <!-- fileList放在这里每次更新会有个东鑫渲染的效果，无法去掉遂挪到外部渲染 -->
      <!-- <template #file="{ file }">
        <div class="file_item">
          <span><folder-opened class="folder" />{{ file.name }}</span>
          <span @click="handleRemove"><delete class="del" /></span>
        </div>
      </template> -->
    </el-upload>
    <div class="file_item" v-for="file in fileList" :key="file.name">
      <span><folder-opened class="folder" />{{ file.name }}</span>
      <span @click="handleRemove('click')"><delete class="del" v-if="canEdit" /></span>
    </div>
  </div>
</template>

<script>
import { reactive, watch, toRefs } from 'vue';
import { ElMessage } from 'element-plus';
import { Delete, FolderOpened } from '@element-plus/icons';
import { useStore } from 'vuex';
import ApplicantApi from '../../service/api/applicant';
import { BASIC } from '../../utils/resume';
import { getToken } from '../../service/cookie';

export default {
  name: 'Other',
  components: { Delete, FolderOpened },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    isSpecific: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['callback', 'update:modelValue'],
  setup(props, context) {
    const state = reactive({
      formRef: null,
      formData: { ...props.modelValue },
      rules: {},
      fileList: [],
    });
    watch(
      () => props.modelValue,
      (value) => {
        try {
          state.fileList = JSON.parse(value.fileUrl) || [];
        } catch {
          state.fileList = [];
        }
      },
    );

    const beforeUpload = (file) => {
      if (!props.modelValue.id) {
        ElMessage.warning('请先填写基本信息');
        return false;
      }
      const formatIsOk = ['application/pdf'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 50;

      if (!formatIsOk) {
        ElMessage.error('文件必须是PDF格式!');
      }
      if (!isLt2M) {
        ElMessage.error('文件大小不能超过50MB!');
      }
      return formatIsOk && isLt2M;
    };
    const handleExceed = () => {
      ElMessage.warning(`限制上传1个附件，如需修改请先删除`);
    };

    const store = useStore();
    const handleRemove = async (action) => {
      if (!props.modelValue.id || action !== 'click') return;
      //if (props.modelValue.editable !== 1)
      //  return ElMessage.warning("请取消投递后再更改简历");
      const userInfo = store.state.userInfo;
      const formData = {
        fileUrl: '',
        id: props.modelValue.id,
        userId: userInfo.userId,
      };
      try {
        await ApplicantApi.updateResumeSelective(formData);
        ElMessage.success('删除成功');
        context.emit('callback');
      } catch (e) {
        console.error('删除附件失败');
      }
    };
    const handleSuccess = async (res, file) => {
      if (res.code === 200 && res.data && res.data.url) {
        const userInfo = store.state.userInfo;
        const formData = {
          fileUrl: JSON.stringify([{ name: file.name, url: res.data.url }]),
          id: props.modelValue.id,
          userId: userInfo.userId,
        };
        try {
          await ApplicantApi.updateResumeSelective(formData);
          ElMessage.success('上传成功');
          context.emit('callback');
        } catch (e) {
          console.error('上传附件失败');
        }
      } else {
        ElMessage.error('上传失败，请稍后重试');
      }
    };
    return {
      ...toRefs(state),
      beforeUpload,
      handleExceed,
      handleRemove,
      handleSuccess,
      getToken,
      BASIC,
    };
  },
};
</script>

<style scoped lang="scss">
.other {
  margin-bottom: 30px;
}
.title {
  color: #000;
  font-size: 20px;
  padding: 20px;
  font-weight: 600;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background: #409eff;
    left: 8px;
    top: 24px;
  }
  .el-upload__tip {
    font-weight: 400;
  }
}
.desc {
  padding-left: 30px;
  font-size: 13px;
  margin-bottom: 20px;
}
.file_item {
  font-size: 15px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  padding: 20px 30px;
  &:hover {
    color: #409eff;
    box-shadow: 0 0 4px 0 rgb(0 0 0 / 30%);
    border-radius: 4px;
    .del {
      display: inline-block;
    }
  }
  .del {
    display: none;
    cursor: pointer;
  }
  .folder {
    margin-right: 6px;
    width: 20px;
    vertical-align: middle;
  }
}
</style>
